import React, { useEffect, useState, useCallback } from "react";
import {
  Box, Typography, TextField, Button, Grid,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchCustomerCategory, updateCustomerCategory } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function CustomerCategoryEditPage() {
  const { businessDomainId, businessUnitId, categoryId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  // APIから取得した全フィールドを保持（サーバーに返す際に失わないため）
  const [original, setOriginal] = useState(null);
  const [form, setForm] = useState({
    customerCategoryName: "",
    customerCategoryDescription: "",
  });

  const loadData = useCallback(async () => {
    try {
      const d = await fetchCustomerCategory(categoryId);
      setOriginal(d);
      setForm({
        customerCategoryName: d.customerCategoryName || "",
        customerCategoryDescription: d.customerCategoryDescription || "",
      });
    } catch (e) { notify.apiError(e); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId]);

  useEffect(() => { loadData(); }, [loadData]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!original) return;
    try {
      await updateCustomerCategory({
        ...original,
        customerCategoryName: form.customerCategoryName,
        customerCategoryDescription: form.customerCategoryDescription || null,
      });
      notify.success(t("message.update.success"));
      navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/customer-categories/${categoryId}`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("customerCategory.edit.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>

          {/* 顧客タイプ（編集不可・表示のみ） */}
          <Grid size={12} md={6}>
            <TextField
              fullWidth disabled
              label={t("customerCategory.customerType")}
              value={original?.customerTypeName || ""}
            />
          </Grid>

          {/* 顧客カテゴリ名 */}
          <Grid size={12} md={6}>
            <TextField
              fullWidth required
              label={t("customerCategory.name")}
              name="customerCategoryName"
              value={form.customerCategoryName}
              onChange={handleChange}
            />
          </Grid>

          {/* 説明 */}
          <Grid size={12}>
            <TextField
              fullWidth multiline rows={3}
              label={t("customerCategory.description")}
              name="customerCategoryDescription"
              value={form.customerCategoryDescription}
              onChange={handleChange}
            />
          </Grid>

        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/customer-categories/${categoryId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
